import type { ProblemExecutorsApiGetProblemExecutorsRequest } from '@/core/generated/api';
import { cleanPhone } from '@/shared/lib/phone';
import type { ProblemExecutorSearchFilters } from './model/types';

/** Подготавливает критерии поиска участников отзыва и питомца */
export const toProblemExecutorSearchRequest = (
    filters: ProblemExecutorSearchFilters
): ProblemExecutorsApiGetProblemExecutorsRequest => ({
    executorFioSearch: filters.executorFioSearch.trim() || undefined,
    executorPhoneSearch: cleanPhone(filters.executorPhoneSearch) ?? undefined,
    clientNameSearch: filters.clientNameSearch.trim() || undefined,
    clientPhoneSearch: cleanPhone(filters.clientPhoneSearch) ?? undefined,
    petNameSearch: filters.petNameSearch.trim() || undefined,
});
